/**
 * Nome da camada a pedir ao GeoServer no zoom atual: rasters com versão
 * detalhada trocam de typename a partir do limiar. Extraído para função pura
 * porque tanto o hook `useActiveRasterTypename` (usado por componentes React
 * que renderizam a camada) quanto código imperativo (amostragem de perfil,
 * GetFeatureInfo do hover) precisam da mesma decisão — se cada um decidisse
 * por si, a consulta de valores poderia divergir da imagem exibida na tela.
 */
export function pickActiveRasterTypename(
  zoom: number,
  typename: string,
  detailedLayerName?: string,
  detailedLayerZoomThreshold = 12
): string {
  return detailedLayerName && zoom >= detailedLayerZoomThreshold
    ? detailedLayerName
    : typename;
}
